import { useHistory } from 'react-router';
import * as LighthouseService from 'common/services/lighthouse.service';
import { ARTICLE_IDS } from '@linearb/linjs-common';
import MenuButton, {
  MenuButtonItem,
  ICON_POSITIONS
} from 'components/MenuButton';
import {
  selectedTeamSelector,
  uiStateSelector
} from 'state/selectors/ui-state';
import { useSelector } from 'react-redux';
import {
  onClickGoToActivity,
  onClickOpenWorkBreakdownTrend
} from './WorkBreakdownNew.service';
import {
  LBAreaChartIcon,
  LBArrowCornerRightUpIcon,
  LBButton,
  LBHelpIcon
} from '@linearb/buzz';

const WorkBreakdownHeader = ({ setAnchorEl, anchorEl }) => {
  const history = useHistory();
  const uiState = useSelector(uiStateSelector);
  const selectedTeam = useSelector(selectedTeamSelector) || {};

  return (
    <div className='grid grid-cols-2 px-4 py-2'>
      <div className='capitalize text-[1.4rem]'>Work Breakdown</div>

      <div className='flex flex-row justify-end'>
        <LBButton
          variant='ghost'
          size='icon'
          onClick={() =>
            LighthouseService.navigateArticle(ARTICLE_IDS.WORK_BREAKDOWN)
          }
        >
          <LBHelpIcon />
        </LBButton>
        <MenuButton
          buttonVariant='ghost'
          width='17rem'
          items={[
            <MenuButtonItem
              text='Work Breakdown Trend'
              key='work-breakdown-trend'
              iconPos={ICON_POSITIONS.beforeText}
              icon={<LBAreaChartIcon />}
              onClick={e => {
                onClickOpenWorkBreakdownTrend(e, setAnchorEl, anchorEl);
              }}
            />,

            <MenuButtonItem
              text='Go to Activity'
              key='go-to-activity'
              iconPos={ICON_POSITIONS.beforeText}
              icon={<LBArrowCornerRightUpIcon />}
              onClick={() =>
                onClickGoToActivity(uiState, selectedTeam, history)
              }
            />
          ].filter(Boolean)}
        />
      </div>
    </div>
  );
};

export default WorkBreakdownHeader;
